const items = [
  "Mutual Funds",
  "Financial Planning",
  "Goal-Based Investing",
  "Wealth Management",
  "Protection Planning",
  "Your path to financial freedom",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-[#10202E]/[0.06] bg-[#E8EFF4]/60 py-7"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...items, ...items].map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span
            className={
              i % 2
                ? "font-display text-2xl italic text-[#4E6A82]"
                : "font-mono text-xs uppercase tracking-[0.35em] text-[#6E8698]"
            }
          >
            {item}
          </span>
          <span className="mx-12 h-1.5 w-1.5 rotate-45 bg-emerald-500/60" />
        </span>
      ))}
    </div>
  </div>
);
